import { render, staticRenderFns } from "./v-icon.vue?vue&type=template&id=6e78c268&scoped=true&"
import script from "./v-icon.vue?vue&type=script&lang=js&"
export * from "./v-icon.vue?vue&type=script&lang=js&"
import style0 from "./v-icon.vue?vue&type=style&index=0&id=6e78c268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e78c268",
  null
  
)

export default component.exports